import {Spinner} from "./Spinner";
import React from "react";

export const PageSpinner = ({text = "Loading..."}) => {
    return (
        <div className="h-screen w-full flex items-center content-center justify-center">
            <Spinner text={text}/>
        </div>
    );
}